module.exports = __webpack_public_path__ + "static/media/steamcouture-3.626cfc79.jpg";